export class OTA_UniqueID {
    public uniqueID: string;
    public type: string;
}